const styles = theme => ({
  root: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2),
  },
  containerDate: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(2),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
})

export default styles
